import {emptyGuid} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";

export const emptyBraillerHistoryModel = {
    loanId: emptyGuid,
    repairId: null,
    catalogItemTitle: "",
    model: "",
    serialNumber: "",
    patronName: "",
    studentName: "",
    shippingLocationName: "",
    checkedOutDate: null,
    dueDate: null,
    dateReturned: null,
    status: "",
    statusDisplay: "",
    isOverdue: false,
    daysOverdue: 0,
    notes: "",
};

export const braillerHistory = (item: Record<string, any>) => {
    const checkedOutDate = item?.checkedOutDate || item?.CheckedOutDate || null;
    const dueDate = item?.dueDate || item?.DueDate || null;
    const returnedDate = item?.dateReturned  || null;

    const loanId = item?.loanId || item?.braillerLoanId || item?.BraillerLoanId || emptyGuid;
    const repairId = item?.repairId || item?.braillerRepairId || item?.BraillerRepairId || null;
    
    const statusDisplay = item?.statusDisplay || item?.StatusDisplay || "";
    const status = statusDisplay || item?.status || item?.braillerLoanStatus?.toString() || "";

    // For loans, patronName comes from patron.fullName; for unloaned repairs, it comes from patronName directly (set to ReportedBy)
    const patronName = item?.patron?.fullName || item?.patronFullName || item?.patronName || item?.PatronName || "";

    return {
        ...emptyBraillerHistoryModel,
        loanId,
        repairId,
        catalogItemTitle: item?.catalogItemTitle || item?.CatalogItemTitle || "",
        model: item?.model || item?.Model || "",
        serialNumber: item?.inventoryBarCode || item?.InventoryBarCode || "",
        shippingLocationName: item?.shippingLocationName || item?.ShippingLocationName || "",
        checkedOutDate,
        checkedOutDateFormatted: checkedOutDate ? convertDateToPrintString(checkedOutDate) : "",
        dueDate,
        dueDateFormatted: dueDate ? convertDateToPrintString(dueDate) : "",
        dateCreatedFormatted: item.dateCreatedUtc ? convertDateToPrintString(item.dateCreatedUtc) : "",
        returnedDate,
        returnedDateFormatted: returnedDate ? convertDateToPrintString(returnedDate) : "",
        status,
        statusDisplay,
        isOverdue: item?.isOverdue ?? item?.IsOverdue ?? false,
        daysOverdue: item?.daysOverdue ?? item?.DaysOverdue ?? 0,
        notes: item?.notes ?? item?.BraillerLoanNotes ?? "",
        patronName,
        type: item.type,
    };
};